import styled from '@emotion/styled';

import { Button } from '@britishcouncil/react-solas';

import {Pagination} from "../../../../components";

export const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

export const CancelButton = styled(Button)`
  border-color: #ab0033 !important;
  color: #ab0033 !important;
`;

export const SelectedModeText = styled.p`
  font-size: 16px;
  color: black;
`;

export const  StyledPagination = styled(Pagination)`
    padding-top: 25px;
  `;

export const FooterButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  margin-top: 24px;
`;

export const DiscardButton = styled(Button)<{ disabled?: boolean }>`
  border-color: #54565a !important;
  color: #54565a !important;
`;

export const ConfirmButton = styled(Button)`
  border-color: #00953b !important;
  color: #00953b !important;
`;
